var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 5h3.578v11H0zM13.324 5.129c-.038-.012-.074-.025-.114-.036a2.32 2.32 0 00-.145-.028A3.207 3.207 0 0012.423 5c-2.086 0-3.409 1.517-3.845 2.103V5H5v11h3.578v-6s2.704-3.766 3.845-1v7H16V8.577a3.568 3.568 0 00-2.676-3.448z","key":0}),React.createElement("circle",{"cx":"1.75","cy":"1.75","r":"1.75","key":1})]);
}

LinkedinInline.defaultProps = {"fill":"inherit","viewBox":"0 0 16 16","width":"288","height":"288"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
